export default function (product) {
  this.article_number = product.article_number ? product.article_number : product.id;
  this.name = product.name;
  this.unit_price = product.price;
  this.quantity = product.quantity ? product.quantity : 1;
  this.remarks = product.remarks ? product.remarks : null;
  this.is_discount_percentage = 0;
  this.discount = 0;
  this.parent_id = product.parent_id ? product.parent_id : null;
}
